import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const ButtonWrapper = styled.button`
    width: 104px;
    height: 32px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    
    background: #FFFFFF;
    /* default/gray/300 */
    border: 1px solid #E2E8F0;
    box-sizing: border-box;
    /* shadow-base */
    box-shadow:  ${({disabled}) => (!disabled ? '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)' : 'none')};
    border-radius: 4px;
    
    /* text-base/Regular */
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    
    background: ${({disabled}) => (disabled ? 'var(--color-gray-300)' : 'white')};
    
    /* default/gray/900 */
    color: ${({disabled}) => (disabled ? 'var(--color-white)' : 'var(--color-gray-900)')};
    
    :hover {
      // eslint-disable-next-line max-len
      background:  ${({disabled}) => (!disabled ? 'rgba(118,118,117,0.28) radial-gradient(circle, transparent 1%, rgba(118,118,117,0.17) 1%) center/15000%' : 'var(--color-gray-300)')};
    }
    
    :active {
      background-color: rgba(118,118,117,0.5);
      background-size: 100%;
      transition: background 0s;
    }
    
    :focus {
        outline: none
    }
`;

function ActionButton3(props) {
    return (
        <ButtonWrapper onClick={props.onClick} disabled={props.disabled}>
            {props.children}
        </ButtonWrapper>
    );
}

ActionButton3.propTypes = {};
ActionButton3.defaultProps = {};

export default ActionButton3;
